module.exports = __webpack_public_path__ + "img/ai11@2x.5ce4a802.png";